"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ramperDefaultConfig = exports.AUTH_SERVICE = exports.APP_NAME = exports.authConfig = void 0;
var ethereum_1 = require("@ramper/ethereum");
exports.authConfig = {
    clientId: 'BMS9HawniJAXZISAsVZ2OVuyw93KVoJAWnNajC0GkyH7xAz6PuH7NBpGCHwB0mdG8gKec5Y_OetfVlhVSJHG9d0',
    ramperAppId: 'rwhbioykjx',
};
exports.APP_NAME = 'Leap App';
exports.AUTH_SERVICE = {
    ramper: 'ramper',
    web3auth: 'web3auth',
};
exports.ramperDefaultConfig = { appName: exports.APP_NAME, theme: ethereum_1.THEME.LIGHT };
